import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MatIconModule} from '@angular/material/icon';
import {HelpContentModule} from '../../common/help-content/help-content.module';
import {HelpNavBackModule} from '../../common/help-nav-back/help-nav-back.module';
import {HelpManualLatencyCorrectionContentComponent} from './help-manual-latency-correction-content/help-manual-latency-correction-content.component';
import {HelpManualLatencyCorrectionComponent} from './help-manual-latency-correction.component';

@NgModule({
  declarations: [
    HelpManualLatencyCorrectionComponent,
    HelpManualLatencyCorrectionContentComponent
  ],
  exports: [
    HelpManualLatencyCorrectionComponent,
    HelpManualLatencyCorrectionContentComponent
  ],
  imports: [
    CommonModule,
    HelpContentModule,
    HelpNavBackModule,
    MatIconModule,
    MatButtonModule
  ]
})
export class HelpManualLatencyCorrectionModule {}
